<template>
  <div class="col-12 col-md-6 col-xl-8 product-page-photo-wrapper">
    <div class="row">
      <div class="col-12 product_page_gallery_wrapper">
        <div class="row">

          <!--multiple product photos -->
          <div class="col-12 col-lg-6 product_gallery_thumbs_col" v-if="galleryImages.length > 1">
            <div class="row">
              <div class="col-12 product_video_col" v-show="productData.video">
                <div class="embed-responsive embed-responsive-16by9">
                  <iframe class="embed-responsive-item" :src="`https://www.youtube.com/embed/${productData.video}?rel=0`" allowfullscreen></iframe>
                </div>
              </div>
              <div class="col-12 product_photo_grid">
                <template v-for="navigationThumbs in galleryImagesSorted">
                  <img :src="navigationThumbs['small']"
                       :key="navigationThumbs['small']"
                       class="img-fluid"
                       @click="mainImage = navigationThumbs"
                       :alt="productCodeId"/>
                </template>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6 product_main_photo" v-if="galleryImages.length > 1 && mainImage">
            <img :src="mainImage['large']" alt="" class="img-fluid"/>
          </div>
          <!--multiple product photos end-->

          <!--single product photo-->
          <div class="col-12 product_gallery_no_thumbs"  v-if="galleryImages.length === 1 && mainImage">
            <div class="row">
              <div class="col-12 col-lg-6 product_video_col" v-show="productData.video">
                <div class="embed-responsive embed-responsive-16by9">
                  <iframe class="embed-responsive-item" :src="`https://www.youtube.com/embed/${productData.video}?rel=0`" allowfullscreen></iframe>
                </div>
              </div>
              <div class="col-12 col-lg-6 single_product_photo_col">
                <img :src="mainImage['large']" alt="" class="img-fluid"/>
              </div>
            </div>
          </div>
          <!--single product photo end-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../../vue/store'
import productMixin from './mixins/productMixins'

export default {
  name: 'AdvProductGallery',
  props: {
    productId: {
      type: Number
    },
    mainImageFirst: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  mixins: [productMixin],
  data () {
    return {
      productCodeId: null,
      mainImage: null,
      galleryImages: [{
        is_main: '1',
        original: store.state.noImage,
        small: store.state.noImage,
        medium: store.state.noImage,
        large: store.state.noImage
      }]
    }
  },
  computed: {
    selectedAttributeId () {
      return store.getters.getSelectedAttributeId
    },
    selectedProductCodeId () {
      return store.getters.getSelectedProductCodeId
    },
    galleryImagesSorted () {
      if (!this.mainImageFirst) {
        return this.galleryImages
      }
      const images = this.galleryImages
      return images.sort(function (a, b) { return a.is_main === '1' ? -1 : b.is_main === '1' ? 1 : 0 })
    }
  },
  watch: {
    selectedProductCodeId (val) {
      this.productCodeId = val
      this.setUpGalleryUpdate()
    },
    selectedAttributeId (attributeId) {
      const productCode = this.productData.productCodes.find(item => item.productCodeAttributes.includes(attributeId))
      this.setUpGalleryUpdate(productCode.productCodeId)
    }
  },
  mounted () {
    this.setProductCodeId()
    this.setUpGalleryUpdate()
  },
  methods: {
    setUpGalleryUpdate (codeId = null) {
      this.productCodeImages(codeId)
      this.setMainImage()
    },
    setProductCodeId () {
      if (this.selectedProductCodeId) {
        this.productCodeId = this.selectedProductCodeId
      } else {
        this.productCodeId = parseInt(Object.keys(this.productData.images)[0])
      }
    },
    productCodeImages (codeId = null) {
      if (!(codeId === null)) {
        this.galleryImages = this.productData.images[parseInt(codeId)]
      } else if (!(this.productCodeId === null)) {
        this.galleryImages = this.productData.images[this.productCodeId]
      }
    },
    setMainImage () {
      this.mainImage = this.galleryImages.find(image => image.is_main === '1')
    }
  }
}
</script>
